import React from 'react'
import replyLogoUrl from '../../assets/logos/reply-logo-white.svg';
import jemibLogoUrl from '../../assets/logos/jemib-logo-white.svg';

const info = [
  { label: 'Photo&Video Privacy Notice and Waiver', href: '/PhotoVideoWaiver.pdf' },
  { label: 'Intellectual Propriety', href: '/IntellectualProperty.pdf' },
  { label: 'Reply Privacy Notice', href: '/PrivacyNotice.pdf' },
];

const evento = [
  { label: "Event", href: '#evento' },
  { label: 'Format', href: '#format' },
  /*{ label: 'Prizes', href: '#premi' },*/
  { label: 'Schedule', href: '#programma' },
  { label: 'Contacts', href: '#contatti' },
  { label: 'Register', href: '#iscriviti' },
];

const social = [
  { label: 'Instagram', href: 'https://www.instagram.com/jemib_bicocca/' },
  { label: 'LinkedIn', href: 'https://Linkedin.com/company/jemib---junior-enterprise-milano-bicocca' },
  { label: 'Tiktok', href: 'https://www.tiktok.com/@jemib_bicocca' },
];

const social_reply = [
  { label: 'Instagram', href: 'https://www.instagram.com/replyulabs/'},
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/reply/'},
  { label: 'Facebook', href: 'https://www.facebook.com/ReplyUlabs/'},
  { label: 'Twitter', href: 'https://twitter.com/replyulabs?lang=en'},
];

function Column({ title, links, external = false }) {
  return (
    <div>
      <h3 className="mb-4 font-mono text-xs uppercase tracking-widest text-brand-white/50">
        {title}
      </h3>
      <ul className="space-y-2">
        {links.map((l) => (
          <li key={l.label}>
            <a
              href={l.href}
              {...(external && { target: '_blank', rel: 'noopener noreferrer' })}
              className="font-display text-[15px] text-brand-white transition-colors duration-200 hover:text-brand-blue"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

const Footer = () => {
  return (
    <footer className="border-t border-brand-white/20 bg-black px-6 pb-10 pt-12">
      <div className="mx-auto max-w-[1240px]">
        <div className='w-full flex justify-between'>
            <img src={replyLogoUrl} className="w-40 -translate-x-2" alt="Reply logo"/>
            <img src={jemibLogoUrl} className="w-36 -translate-x-2 md:translate-y-1 lg:translate-y-2" alt="Jemib logo"/>
        </div>


        <div className="grid grid-cols-2 gap-10 md:grid-cols-5 mt-12">
          <div className="col-span-2 md:col-span-1">
            <h3 className="mb-4 font-mono text-xs uppercase tracking-widest text-brand-white/50">
              Student Tech Clash
            </h3>
            <p className="max-w-[28ch] font-display text-[15px] text-brand-white/50">
              AI on Campus. An event by Reply in collaboration with JEMIB and the University of Milano-Bicocca.
            </p>
          </div>

          <Column title="Information" links={info} external/>
          <Column title="Event" links={evento} />
          <Column title="Jemib" links={social} external />
          <Column title="Reply" links={social_reply} external />
        </div>

        <div className="mt-16 flex flex-col gap-2 border-t border-brand-white/20 pt-6 font-mono text-xs uppercase text-brand-white/50 sm:flex-row sm:justify-between">
          <a href="#top" className="transition-colors hover:text-brand-blue">
            Back to top ↑
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer